import PropTypes from 'prop-types';
import { Form, Formik } from 'formik';
import { Badge, Button } from 'react-bootstrap';
import InputFormGroup from './util/InputFormGroup';
import CheckBoxFormGroup from './util/CheckBoxFormGroup';
import useRequireAuth from '../hooks/useRequireAuth';
import useTheme from './hooks/useTheme';
import { useActivateLicenseFormHandlers } from './hooks/useActivateLicenseFormHandlers';

function ActivateLicense({ onComplete }) {
  const auth = useRequireAuth();
  const [theme] = useTheme();
  const { handleSubmit, handleCancel, errorMsg } =
    useActivateLicenseFormHandlers(onComplete);

  const checkboxLabel = (
    <span>
      I have read and agree to the{' '}
      <a
        target="#"
        href="https://www.poly.com/us/en/legal/terms/cloud-terms-of-service"
      >
        Poly RealConnect Cloud Terms of Service
      </a>
    </span>
  );

  return !auth || !auth.tenant ? null : (
    <>
      <Badge variant="danger">{errorMsg}</Badge>
      <br />
      If you have a License Activation Key issued by Polycom, enter that value
      here.
      <br />
      If you do not have a License Activation Key issued by Polycom, please
      contact a Polycom account manager.
      <Formik
        initialValues={{
          eula: false,
          activationKey: '',
        }}
        onSubmit={handleSubmit}
      >
        {({ values, isSubmitting }) => (
          <Form>
            <br />
            <InputFormGroup
              type="text"
              label="License Activation Key"
              name="activationKey"
              pattern="[a-zA-Z0-9\-]{1,50}"
              title="Numbers, letters, dashes only"
              required
            />
            <CheckBoxFormGroup name="eula" label={checkboxLabel} required />

            <Button
              style={{ marginRight: '.15em' }}
              type="submit"
              variant={theme?.buttonVariant}
              size="lg"
              disabled={!values.eula || !values.activationKey || isSubmitting}
            >
              SUBMIT
            </Button>
            <Button
              variant={theme?.buttonVariant}
              size="lg"
              onClick={handleCancel}
            >
              CANCEL
            </Button>
          </Form>
        )}
      </Formik>
    </>
  );
}

ActivateLicense.propTypes = {
  onComplete: PropTypes.func,
};

export default ActivateLicense;
